const filter = () => {

    const hideBtn = document.querySelector('.fndry-btn-filterButtonHide');
    
    if (hideBtn){
        hideBtn.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                hideBtn.removeChild(node);
            }
        });
    }
}

export default filter;